import React from "react";
import { TableCell, Typography, Grid } from "@material-ui/core";
import { observer, inject } from "mobx-react";
import { computed } from "mobx";
import { IValuesStore } from "Stores/Values/types";
import EntityDelete from "@src/Components/Common/EntityDelete/EntityDelete";
import { IManagementStore } from "@src/Stores/Management/types";
import { STTableRow } from "@src/Components/Ui/STTableRow";
import { PositionTeam } from "@src/Interfaces/Entity/PositionTeam";
import { IAuthStore } from "@src/Stores/Auth/types";
import { STTableCellTypography } from "@src/Components/Ui/STTableCellTypography";
import {Values} from "Tools/Values";
import CreateIcon from "@material-ui/icons/Create";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  positionTeam: PositionTeam;
  onEditButtonClick: () => void;
  values?: IValuesStore;
  management?: IManagementStore;
  auth?: IAuthStore;
}

@inject("auth", "values", "management")
@observer
class PositionTeamTableItem extends React.Component<IProps> {
  @computed get isActive() {
    return this.props.positionTeam.state === this.props.values.states.Active;
  }

  @computed get getMembers() {
    return this.props.positionTeam.positions
      .map((positions: string) => {
        const position = this.props.management.activePositions.find(_ => _.id === positions);
        return position ? position.title : "";
      })
      .join(", ");
  }

  handleRemove = async () => {
    await this.props.management.removePositionTeam(this.props.positionTeam.id);
  };

  render() {
    const positionTeam: PositionTeam = this.props.positionTeam;
    return (
      <STTableRow hover isActive={this.isActive}>
        <TableCell component="th" scope="row" size="small">
          <Typography>
            <STTableCellTypography>{positionTeam.name}</STTableCellTypography>
          </Typography>
        </TableCell>
        <TableCell size="small">
          <STTableCellTypography>{positionTeam.description}</STTableCellTypography>
        </TableCell>
        {!this.props.auth.user.location.primary && (
          <TableCell size="small">
            <STTableCellTypography>{this.getMembers}</STTableCellTypography>
          </TableCell>
        )}
        <TableCell align="right" size="small">
          <Grid container wrap="nowrap" justify="flex-end">
            {this.props.auth.user.location.primary && (
              <>
                  <RoundButton
                      icon={<CreateIcon/>}
                      tooltipTitle={Values.getLocalizationValue("edit")}
                      onClick={() => this.props.onEditButtonClick()}
                  />
                  
                  <EntityDelete onSubmit={this.handleRemove} />
              </>
            )}
          </Grid>
        </TableCell>
      </STTableRow>
    );
  }
}

export default PositionTeamTableItem;
